import React from 'react';
import s from './Footer.module.css';

function Footer() {
    return (
        <footer className={s.footer}>
            Copyright 2020 SamuraiSocial All Rights Reserved.
        </footer>
    )
}

export default Footer
